import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores';

/**
 * Layout wrapper that protects routes requiring authentication.
 * Redirects unauthenticated users to /login with a return URL.
 */
export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="auth-loading">
        <p>Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
